import React from 'react';
import Sticky from 'react-stickynode';
import WebsitePreview from '../WebsitePreview';

type WebsitePreviewStickyProps = {
  bottomBoundary?: string | number;
};

const WebsitePreviewSticky: React.FC<WebsitePreviewStickyProps> = ({
  bottomBoundary = '#sticky-preview-anchor',
}) => (
  <Sticky enabled top={170.5} bottomBoundary={bottomBoundary}>
    <WebsitePreview />
  </Sticky>
);
export default WebsitePreviewSticky;
